import { __decorate, __extends, __metadata } from "tslib";
import React from "react";
import { observer } from "mobx-react";
import { TabContext } from "./TabContainer";
import { Misc } from "@singularsystems/neo-core";
import { NeoReactTypes } from "../../Modules/Types";
var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.hasRenderedContents = false;
        _this.iconFactory = Misc.Globals.appService.get(NeoReactTypes.Components.IconFactory);
        _this.onClick = _this.onClick.bind(_this);
        var tabKey = (_a = _this.props.id) !== null && _a !== void 0 ? _a : _this.props.name;
        if (!tabKey) {
            if (typeof _this.props.header === "string") {
                tabKey = _this.props.header;
            }
            else {
                throw Error("'Name' prop must be specified on tab when it's header is a component.");
            }
        }
        _this.tabKey = tabKey;
        return _this;
    }
    Tab.prototype.componentDidMount = function () {
        if (this.props.onInitialise) {
            this.context.tabManager.onTabInitialise(this.tabKey, this.props.onInitialise);
        }
        if (this.props.onDisplayed) {
            this.context.tabManager.onTabDisplayed(this.tabKey, this.props.onDisplayed);
        }
        this.context.tabManager.tabMounted(this.tabKey, this.props.onLeave);
    };
    Tab.prototype.render = function () {
        if (this.isHeader === undefined)
            this.isHeader = this.context.inHeader;
        var isSelected = this.context.tabManager.selectedTab.toLowerCase() === this.tabKey.toLowerCase();
        return this.isHeader ? this.renderHeader(isSelected) : this.renderBody(isSelected);
    };
    Tab.prototype.onClick = function (e) {
        e.preventDefault();
        if (!this.props.disabled) {
            this.context.tabManager.selectedTab = this.tabKey;
        }
    };
    Tab.prototype.renderHeader = function (isSelected) {
        var hasIcon = this.props.icon !== undefined;
        return (React.createElement("li", { className: "nav-item" },
            React.createElement("a", { className: "nav-link" + (isSelected ? " active" : "") + (this.props.disabled ? " disabled" : ""), href: "#", onClick: this.onClick },
                hasIcon && this.iconFactory.getIconComponent(this.props.icon),
                hasIcon && " ",
                this.props.header)));
    };
    Tab.prototype.renderBody = function (isSelected) {
        var forceRender = this.context.keepMounted === true && this.hasRenderedContents;
        if (isSelected) {
            this.hasRenderedContents = true;
        }
        return ((isSelected || forceRender) && React.createElement("div", { className: "tab-pane" + (isSelected ? " show active" : "") }, this.props.children));
    };
    Tab.contextType = TabContext;
    Tab = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], Tab);
    return Tab;
}(React.Component));
export default Tab;
